import { EPeriodDays, ERightType, type ISubscribeProductDTO, type TPaywallSlotProduct } from '@/apis/commerce';

/**
 * 折扣订阅判断：自动续订订阅且服务端下发优惠字段，优惠价低于原价。
 * discount_period_num >= 1 即视为折扣订阅（含首期与多期优惠）。
 * 字段未下发时一律 false，普通订阅保持线上逻辑。
 */
export function isDiscountSubscribe(product: TPaywallSlotProduct | undefined): product is ISubscribeProductDTO {
    if (product?.right_type !== ERightType.Membership) {
        return false;
    }
    const subscribe = product as ISubscribeProductDTO;
    const discountPriceCents = subscribe.discount_price_cents;
    return (
        (subscribe.discount_period_num ?? 0) >= 1 &&
        discountPriceCents != null &&
        discountPriceCents < subscribe.price_cents
    );
}

/** 折扣比例（如 50）；仅折扣订阅有值，取整规则 Math.round */
export function resolveSubscribeDiscountPercent(product: TPaywallSlotProduct): number | undefined {
    if (!isDiscountSubscribe(product)) {
        return undefined;
    }
    return Math.round((1 - (product.discount_price_cents as number) / product.price_cents) * 100);
}

/**
 * 订阅天数 → 卡面标题 i18n key：7/30/90/365 天映射为 Weekly/Monthly/Quarterly/Yearly；
 * 其他天数返回 undefined，由调用方兜底为「x Day」。普通订阅与折扣订阅统一走该规则。
 */
const SUBSCRIBE_DAYS_PLAN_I18N_KEY: Record<number, string> = {
    [EPeriodDays.Week]: 'paywall_plan_weekly',
    [EPeriodDays.Month]: 'paywall_plan_monthly',
    [EPeriodDays.Quarter]: 'paywall_plan_quarterly',
    [EPeriodDays.Year]: 'paywall_plan_annual',
};

/** 按订阅天数解析卡面标题 key，未识别时返回 undefined（调用方自行兜底） */
export function resolveSubscribePlanI18nKey(days?: number): string | undefined {
    return days != null ? SUBSCRIBE_DAYS_PLAN_I18N_KEY[days] : undefined;
}
